import React from 'react';

export const Root: React.FC = ({ children }) => {
  return <>{children}</>;
};
